module.exports = __webpack_public_path__ + "static/img/qq_selec.bc75c146.svg";